export class CheckoutPaymentRequiredError extends Error {
  constructor() {
    super('Cart must be paid before the order can be placed')
    this.name = 'CheckoutPaymentRequiredError'
  }
}
